import { ISiteNameSansId } from '../../ts/ServerApi/types/ISiteNameSansId';
import { SiteNameSansIds } from '../../ts/siteManagement/services/resources/SiteNameSansIds';
import { StoreHelpers } from './StoreHelpers';

export class SiteStore {

  constructor(private siteNames: SiteNameSansIds) { }

  public getAll(): Q.Promise<ISiteNameSansId[]> {
    return StoreHelpers.getAll<ISiteNameSansId>(this.siteNames.all());
  }

}
